export const pathReduces = (state: string) => state || '';
